import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["addBoothForm", "addBoothButton"]
  connect() {
  }

  changeFestivalYear(event) {
    console.log(event.target.value)
    window.location.href = `/crush/vendors?festival_year=${event.target.value}`
  }

  addBooth() {
    console.log('addBooth')
    if (this.hasAddBoothFormTarget) {
      this.addBoothFormTarget.classList.remove('hidden')
    }
    if (this.hasAddBoothButtonTarget) {
      this.addBoothButtonTarget.classList.add('hidden')
    }
  }

  cancelAddBooth() {
    console.log('cancelAddBooth')
    if (this.hasAddBoothFormTarget) {
      this.addBoothFormTarget.classList.add('hidden')
    }
    if (this.hasAddBoothButtonTarget) {
      this.addBoothButtonTarget.classList.remove('hidden')
    }
  }
}
